export default defineNuxtRouteMiddleware((_to, _from) => {
	// Intentionally empty
});
